import React from 'react';
import {
  Text,
  Flex,
  useColorModeValue
} from '@chakra-ui/react';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';

function TranscriptsView4() {
    const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Flex direction="column" pt={{ base: '120px', md: '5px', width: '100%' }} overflowY="auto">
      <Card overflowX={{ sm: 'auto', xl: 'hidden' }}>
        <CardHeader p="6px 0px 22px px">
          <Flex flexDirection="column" mb={4}>
            <Text fontSize="xl" color={textColor} fontWeight="bold" mt={4}>
              Busca Avançada em construção
            </Text>
          </Flex>
        </CardHeader>
      </Card>
      <Flex flex={1} justifyContent="center">
      </Flex>
    </Flex>
  );
}


export default TranscriptsView4;